import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { servicesApi as r } from "@maat/api-main";
//#region src/services/useArchiveServiceMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.archiveService(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useArchiveServiceMutation };
